import './prodConsole';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@phosphor-icons/web/regular';
import '@phosphor-icons/web/bold';
import '@phosphor-icons/web/fill';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { ensureCesiumBaseUrl, isShopifyAppPath } from './utils/cesiumBaseUrl';
import { isMarketingPrerenderPath } from './utils/marketingPrerenderPaths';

/** Benign browser warning — CRA dev overlay treats it as fatal when layout observers nest. */
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const resizeObserverLoop =
    /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
  window.addEventListener('error', (event) => {
    if (resizeObserverLoop.test(event.message || '')) {
      event.stopImmediatePropagation();
    }
  });
}

/** Studio map only — Shopify never mounts Cesium, so skip the worker base URL there. */
if (typeof window !== 'undefined' && !isShopifyAppPath()) {
  ensureCesiumBaseUrl();
}

const rootElement = document.getElementById('root');
const app = (
  <AuthProvider>
    <App />
  </AuthProvider>
);

// Prerendered marketing HTML (optional npm run seo:snap) — hydrate instead of replace.
// Hosting rewrites /studio, /login, etc. to index.html (the homepage snapshot). Hydrating
// that markup onto a different URL leaves the landing page visible while the address bar updates.
const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/';
const shouldHydrate =
  rootElement.hasChildNodes() && isMarketingPrerenderPath(currentPath);
if (shouldHydrate) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  if (rootElement.hasChildNodes()) {
    rootElement.innerHTML = '';
  }
  const root = ReactDOM.createRoot(rootElement);
  // StrictMode disabled so the 3D viewer (SuperSplat) mounts once. Double-mount was leaving the wrong
  // viewer instance in the DOM and aborting the load that had splats.
  root.render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
